import { Controller } from "@hotwired/stimulus"

// Submits the associated form when the select changes
// Usage: add data-controller="auto-submit" and data-action="change->auto-submit#submit" to the select
export default class extends Controller {
  submit(event) {
    const form = this.element.form || event.target.form
    if (!form) return
    if (typeof form.requestSubmit === "function") {
      form.requestSubmit()
    } else {
      form.submit()
    }
  }
}
